import Vue from 'vue'
import App from './schedule/app.vue'
import TurbolinksAdapter from 'vue-turbolinks';

Vue.use(TurbolinksAdapter)

document.addEventListener('turbo:load', () => {
  const calendar = document.getElementById('schedule-calendar');

  if (calendar) {
    new Vue({
      el: '#schedule-calendar',
      render: h => h(App)
    }).$mount();
  }
});